export const applicanttrackingapplicantsdata = [
  {
    Name: "John Smith",
    Languages: ["English", "Spanish"],
    Role: "Software Engineer",
    Locations: "New York, NY",
    Education: "Bachelor's",
    Skills: ["Java", "Python"],
    Status: "Active",
  },
  {
    Name: "Alice Johnson",
    Languages: ["English", "French"],
    Role: "Data Scientist",
    Locations: "San Francisco, CA",
    Education: "Master's",
    Skills: ["R", "Python", "SQL"],
    Status: "Inactive",
  },
  {
    Name: "Bob Brown",
    Languages: ["English", "German"],
    Role: "Product Manager",
    Locations: "Chicago, IL",
    Education: "Bachelor's",
    Skills: ["Agile", "Leadership"],
    Status: "Active",
  },
  {
    Name: "Eve Davis",
    Languages: ["English", "Mandarin"],
    Role: "UX Designer",
    Locations: "Los Angeles, CA",
    Education: "Bachelor's",
    Skills: ["Figma", "Sketch", "Adobe XD"],
    Status: "Active",
  },
  {
    Name: "Charlie Wilson",
    Languages: ["English", "Italian"],
    Role: "DevOps Engineer",
    Locations: "Austin, TX",
    Education: "Master's",
    Skills: ["Docker", "Kubernetes", "AWS"],
    Status: "Inactive",
  },
  {
    Name: "Grace Martinez",
    Languages: ["English", "Portuguese"],
    Role: "Quality Assurance Engineer",
    Locations: "Miami, FL",
    Education: "Bachelor's",
    Skills: ["Selenium", "Jenkins", "Manual Testing"],
    Status: "Active",
  },
  {
    Name: "David Lee",
    Languages: ["English", "Korean"],
    Role: "Software Engineer",
    Locations: "Seattle, WA",
    Education: "Master's",
    Skills: ["Java", "JavaScript", "React"],
    Status: "Active",
  },
  {
    Name: "Sophia Taylor",
    Languages: ["English", "French"],
    Role: "Business Analyst",
    Locations: "Boston, MA",
    Education: "Bachelor's",
    Skills: ["Excel", "Data Modeling", "SQL"],
    Status: "Inactive",
  },
  {
    Name: "Michael Garcia",
    Languages: ["English", "Spanish"],
    Role: "System Administrator",
    Locations: "Dallas, TX",
    Education: "Associate's",
    Skills: ["Linux", "Networking", "VMware"],
    Status: "Active",
  },
  {
    Name: "Olivia Walker",
    Languages: ["English", "Italian"],
    Role: "Software Engineer",
    Locations: "San Diego, CA",
    Education: "Master's",
    Skills: ["Python", "Django", "PostgreSQL"],
    Status: "Active",
  },
  {
    Name: "James Harris",
    Languages: ["English", "German"],
    Role: "Product Designer",
    Locations: "Atlanta, GA",
    Education: "Bachelor's",
    Skills: ["Sketch", "UX Research", "Prototyping"],
    Status: "Inactive",
  },
  {
    Name: "Isabella Clark",
    Languages: ["English", "Spanish"],
    Role: "Software Engineer",
    Locations: "New York, NY",
    Education: "Master's",
    Skills: ["JavaScript", "Node.js", "Express"],
    Status: "Active",
  },
  {
    Name: "Liam Lewis",
    Languages: ["English", "French"],
    Role: "Data Engineer",
    Locations: "Denver, CO",
    Education: "Bachelor's",
    Skills: ["Python", "Hadoop", "SQL"],
    Status: "Inactive",
  },
  {
    Name: "Lucas Young",
    Languages: ["English", "Italian"],
    Role: "Cloud Engineer",
    Locations: "Chicago, IL",
    Education: "Bachelor's",
    Skills: ["AWS", "Terraform", "Docker"],
    Status: "Active",
  },
  {
    Name: "Mia King",
    Languages: ["English", "Russian"],
    Role: "Front-end Developer",
    Locations: "San Francisco, CA",
    Education: "Bachelor's",
    Skills: ["HTML", "CSS", "JavaScript"],
    Status: "Inactive",
  },
];
